export * from "./services/types";
export * from "./services/aliases";

import type { ServiceDetail } from "./services/types";
import { CORE_SERVICES_DATA } from "./services/coreServices";
import { SPECIALIST_SERVICES_DATA } from "./services/specialistServices";

export const SERVICES_DATA: Record<string, ServiceDetail> = {
  ...CORE_SERVICES_DATA,
  ...SPECIALIST_SERVICES_DATA,
};
